/* unplugin-vue-components disabled */import script from "./authUser.vue?vue&type=script&setup=true&name=AuthUser&lang=js"
export * from "./authUser.vue?vue&type=script&setup=true&name=AuthUser&lang=js"

const __exports__ = script;

export default __exports__